// frontend/src/pages/learning/Event.jsx
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import './Event.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion, faImage} from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';
import EventFlowScanQR from './EventFlowScanQR';
import { useLocation, useNavigate } from 'react-router-dom';
import EventAttendanceAction from './EventAttendanceAction';
import EventFoodCouponSaveAction from './EventFoodCouponSaveAction';


const EventList = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const location = useLocation();
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);

    const [myEnrollments, setMyEnrollments] = useState([]);
    const [events, setEvents] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedEnrollmentId, setSelectedEnrollmentId] = useState([]);

    const [selectedEventId, setSelectedEventId] = useState([]);
    const [showItineraryClicked, setShowItineraryClicked] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [showSplInstruction, setShowSplInstruction] = useState(false);
    const [showHallTicket, setShowHallTicket] = useState(false);
    const [showFoodVoucher, setShowFoodVoucher] = useState(false);
    const [markAttendance, setMarkAttendance] = useState(false);

    const [scannedData, setScannedData] = useState('');
    const [scannedUserName, setScannedUserName] = useState('');
    const [scannedUserCode, setScannedUserCode] = useState('');
    const [consumedBy, setConsumedBy] = useState('');
    const [mealType, setMealType] = useState('Any Meal');
    const [isChild, setIsChild] = useState(false);

    const [showAttendance, setShowAttendance] =useState(false);
    const [showFoodVoucherScroll, setShowFoodVoucherScroll] =useState(false);

    const [eventAttendance, setEventAttendance] =useState([]);
    const [eventFoodCouponScroll, setEventFoodCouponScroll] =useState([]);

    const listPage = (location?.pathname || '').split('/').pop() || '';
        
    const buttonStyle = {
      marginLeft: '10px',
      padding: '5px 10px',
      fontSize: '14px',
      cursor: 'pointer',
      borderRadius: '5px',
      border: 'none',
      backgroundColor: '#25D366',
      color: '#fff'
    };

    const button1Style = {
      margin: '10px',
      padding: '10px',
      fontSize: '16px',
    };

    const fetchEvents = useCallback(() => {
      const config = { 
        url: "/events/eventlist", 
        method: "get", 
        headers: { Authorization: authState.token } 
      };
      // console.log("EventFlow Config: ",config)
  
      fetchData(config, { showSuccessToast: false })
      .then(({ events }) => setEvents(events))
      .catch(error => console.error("Error fetching data:", error));
  
      }, [authState.token, fetchData]);
  
    useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchEvents();
    }, [authState.isLoggedIn, fetchEvents]);
  
    const sortedEvents = [...events].sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
  
    const handleEventView = (_id) => {
      setSelectedEventId(prevId => (prevId === _id ? null : _id));
    };

    // Call method
    const handleCallClick = (contactNumber) => {
      window.location.href = `tel:${contactNumber}`;
    };
  
    // WhatsApp method
    const handleWhatsAppClick = (contactNumber) => {
      const whatsappUrl = `https://wa.me/${contactNumber}`;
      window.open(whatsappUrl, '_blank');
    };
  
    // Email method
    const handleEmailClick = (contactEmail) => {
        window.location.href = `mailto:${contactEmail}`;
    };
    
    const handleItineraryClick = () => {
      setShowItineraryClicked(prevState => !prevState);
    };
  
    const formatDateTime = (date) => {
      const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const [selectedAction, setSelectedAction] = useState('');

  const handleButtonClick = (action) => {
    setSelectedAction(action);
  };

  const handleShowImage = () => {
    setShowImage(!showImage);
  };

  const handleShowSplInstructions = () => {
    setShowSplInstruction(!showSplInstruction);
  };

  const handleShowHallTicket = () => {
    setShowHallTicket(!showHallTicket);
  };

  const handleShowFoodVoucher = () => {
    setShowFoodVoucher(!showFoodVoucher);
  };

  const [foodVoucherScanned,setFoodVoucherScanned]=useState(false);
  const handleScanFoodVoucher = () => {
    setFoodVoucherScanned(!foodVoucherScanned);
  };

  const handleShowFoodVoucherScroll = (eventId) => {
    // console.log("handleShowFoodVoucherScroll",eventId);
    setShowFoodVoucherScroll(!showFoodVoucherScroll);
    fetchEventFoodVoucherScroll(eventId);
  };

  const fetchEventFoodVoucherScroll = useCallback((eventId) => {
    const config = { 
      url: "/eventfoodcoupon/usedfoodcouponslist", 
      method: "post", 
      headers: { Authorization: authState.token },
      data: { eventId: eventId}
    };
    // console.log("usedfoodcouponslist Config: ",config)

    fetchData(config, { showSuccessToast: false })
    .then(({ usedFoodCouponList }) => setEventFoodCouponScroll(usedFoodCouponList))
    .catch(error => console.error("Error fetching data:", error));
    }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchEventFoodVoucherScroll();
  }, [authState.isLoggedIn, fetchEventFoodVoucherScroll]);

  const sortedEventFoodCouponScroll = [...eventFoodCouponScroll].sort((a, b) => new Date(b.scannedDate) - new Date(a.scannedDate));

  const handleMarkAttendance = () => {
    setMarkAttendance(!markAttendance);
  };

  const handleAttendanceRegister = (eventId) => {
    setShowAttendance(!showAttendance);
    fetchEventAttendanceRegister(eventId);
  };

  const fetchEventAttendanceRegister = useCallback((eventId) => {
    const config = { 
      url: "/eventattendance/attendancelist", 
      method: "post", 
      headers: { Authorization: authState.token },
      data: { eventId: eventId}
    };
    // console.log("eventattendance Config: ",config)

    fetchData(config, { showSuccessToast: false })
    .then(({ attendanceList }) => setEventAttendance(attendanceList))
    .catch(error => console.error("Error fetching data:", error));
    }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchEventAttendanceRegister();
  }, [authState.isLoggedIn, fetchEventAttendanceRegister]);

  const sortedEventAttendance = [...eventAttendance].sort((a, b) => new Date(b.scannedDate) - new Date(a.scannedDate));

  const handleMakePayment = () => {
    navigate("/wallet-topup");
  };

  const handleRegistration = (eventCode, eventId, eventTitle, isFree, fee, feeDetails, userCode, userName) => {
    navigate("/event-flow-enroll", {
      state: { eventCode, eventId, eventTitle, isFree, fee, feeDetails, userCode, userName }
    });
  };

  
  const handleScanSuccess = (data) => {
    const [userName, userCode, consumedBy] = data.split(','); 
    setScannedData(data); 
    setScannedUserName(userName || "Unknown User");  
    setScannedUserCode(userCode || "Unknown Code");  
    setConsumedBy(consumedBy || "Unknown Consumer");
  };

  const [myRegistrationViewClicked, setMyRegsitrationViewClicked] = useState(false);
  const handleMyRegistration = (eventId) => {
    setMyRegsitrationViewClicked(!myRegistrationViewClicked);
    fetchShowMyRegistration(eventId);
  };

  const [myRegistration, setMyRegistration] = useState(false);

  const fetchShowMyRegistration = useCallback((eventId) => {
    const config = { 
      url: "/events/mydetails", 
      method: "post", 
      headers: { Authorization: authState.token },
      data: { userId: userId, eventId: eventId}
    };
    // console.log("fetchShowMyRegistration Config: ",config)

    fetchData(config, { showSuccessToast: false })
    .then(({ myRegistration }) => setMyRegistration(myRegistration))
    .catch(error => console.error("Error fetching data:", error));
    }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchShowMyRegistration();
  }, [authState.isLoggedIn, fetchShowMyRegistration]);


    return (
        <MainLayout>
          <div className="my-1 mx-auto py-1 min-w-full min-h-[100vh] text-white">
            {/* <div className="text-white"> */}
                <div className="my-2 mx-auto py-4">
                    {events.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-yellow-300  border-b'>({events.length}) Events</h2>}
                    {loading ? (
                    <Loader />
                    ) : (
                    <div className="flex flex-col text-purple-500 text-m px-4">
                        {events.length === 0 ? (
                        <div className='mt-4 my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>Currently there is no Live Events!!</div>
                        ) : (
                        sortedEvents.map((event, index) => (
                            <div key={event._id} className='bg-black my-1 p-4 text-white rounded-md shadow-md mt-4'>
                            <div className='flex flex-row mt-4'>
                                <span>{index + 1}. </span> {event.title}
                                <Tooltip text={"View details"} position={"top"}>
                                <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleEventView(event._id)}>
                                    <i className="fa-solid fa-eye"></i>
                                </span>
                                </Tooltip>
                            </div>
                            {selectedEventId === event._id && (
                                <div className='bg-gray-700 text-white mt-2 px-4'>
                                <p className='text-blue-500 mt-2'>{event.title}</p>
                                <p className='mt-2'>{event.objective}</p>
                                <p className='mt-2'><strong>Date:</strong> {formatDateTime(event.fromDate)}<strong> To</strong> {formatDateTime(event.toDate)}</p>
                                <p className='mt-2'><strong>Timing:</strong>{event.timing}</p>
                                <p className='mt-2'><strong>Venue:</strong>{event.venue}</p>
                                <p className='mt-2'><strong>Organiser:</strong>{event.organiserName}</p>
                                <p className='mt-2'><strong>Remarks:</strong> <span dangerouslySetInnerHTML={{ __html: event.remarks }} /></p>
                                <p className='mt-2'><strong>Fee:</strong>{event.feeDetails}</p>
                                {event.showItinerary && (
                                    <>
                                    <p>
                                        <button 
                                        onClick={() => handleItineraryClick()} 
                                        style={buttonStyle}
                                        >
                                        📅 Show Itinerary
                                        </button>
                                    </p>
                                    {showItineraryClicked && (
                                        <div className='border-1 bg-black text-white' dangerouslySetInnerHTML={{ __html: event.itinerary }} />
                                    )}
                                    </>
                                )}
                                <button style={buttonStyle} onClick={handleShowImage}>
                                  <FontAwesomeIcon icon={faImage} /> View Invitation
                                </button>
                                {showImage && (
                                  <div>
                                    <img 
                                      src={`/api/downloads/events/invitation/${event.eventCode}.png`}
                                      alt="Event Invitation" 
                                      style={{ maxWidth: '100%', height: 'auto' }} 
                                    />
                                  </div>
                                )}
                                <div>
                                  <div className="button-grid">
                                    {listPage !== "my" && (
                                      <p>
                                        <button 
                                          onClick={() => handleRegistration(event.eventCode, event._id, event.title, event.isFree, event.fee, event.feeDetails, userCode, userName)} 
                                        style={button1Style}><i className="fas fa-clipboard-check"></i> 
                                          Registration
                                        </button>
                                      </p>
                                    )}
                                    {listPage === "my" && (
                                      <p><button onClick={() => handleMyRegistration(event._id)} style={button1Style}><i className="fas fa-info-circle"></i> My Registration</button></p>
                                    )}
                                    <p><button onClick={() => handleShowSplInstructions('Special Instructions')} style={button1Style}><i className="fas fa-info-circle"></i> Special Instructions</button></p>
                                    <p><button onClick={() => handleShowHallTicket('Hall Ticket')} className='bg-yellow-400' style={button1Style}><i className="fas fa-ticket-alt"></i> Generate Hall Ticket</button></p>
                                    <p><button onClick={() => handleShowFoodVoucher('Food Voucher')} className='bg-yellow-400' style={button1Style}><i className="fas fa-utensils"></i> Generate Food Vouchers</button></p>
                                    <p><button onClick={() => handleMarkAttendance('Attendance')} className='bg-purple-500' style={button1Style}><i className="fas fa-check-square"></i> Mark Attendance</button></p>
                                    <p><button onClick={() => handleScanFoodVoucher('Scan Food Voucher')} className='bg-purple-500' style={button1Style}><i className="fas fa-utensils"></i> Scan Food Voucher</button></p>
                                    <p><button onClick={() => handleButtonClick('Messages')} style={button1Style}><i className="fas fa-chat"></i> Messages & Updates</button></p>
                                    <p><button onClick={() => handleButtonClick('Frames')} style={button1Style}><i className="fas fa-portrait"></i> Happy Frames</button></p>
                                    
                                    <p><button onClick={() => handleButtonClick('My Certificate')} className='bg-gray-400' style={button1Style}><i className="fas fa-camera"></i> My Certificates</button></p>

                                    <p><button onClick={() => handleButtonClick('Applause Live')} className='bg-gray-400' style={button1Style}><i className="fas fa-camera"></i> Applause Live</button></p>
                                    <p><button onClick={() => handleButtonClick('Lucky Draw')} className='bg-gray-400' style={button1Style}><i className="fas fa-gift"></i> Be Active for Lucky Draw</button></p>                                    
                                    <p><button onClick={() => handleMakePayment('Payment')} className='bg-gray-400' style={button1Style}><i className="fas fa-credit-card"></i> Make Payment</button></p>
                                    <p><button onClick={() => handleButtonClick('Shopping')} className='bg-gray-400' style={button1Style}><i className="fas fa-shopping-cart"></i> Shopping</button></p>
                                    <p><button onClick={() => handleButtonClick('Sponsors')} className='bg-gray-400' style={button1Style}><i className="fas fa-handshake"></i> Sponsors</button></p>
                                    <p><button onClick={() => handleButtonClick('Thanks Giving')} className='bg-gray-400' style={button1Style}><i className="fas fa-hands-helping"></i> Thanks Giving</button></p>
                                    <p><button onClick={() => handleButtonClick('Event Notebook')} className='bg-gray-400' style={button1Style}><i className="fas fa-book"></i> Event Notebook</button></p>
                                    <p><button onClick={() => handleButtonClick('Digital Souvenirs')} className='bg-gray-400' style={button1Style}><i className="fas fa-gift"></i> Digital Souvenirs</button></p>
                                    <p><button onClick={() => handleButtonClick('Order')} className='bg-gray-400' style={button1Style}><i className="fas fa-shopping-cart"></i> Order</button></p>
                                    <p><button onClick={() => handleButtonClick('Lost & Found')} className='bg-gray-400' style={button1Style}><i className="fas fa-search"></i> Lost & Found</button></p>
                                    <p><button onClick={() => handleButtonClick('Certificate Winners')} className='bg-gray-400' style={button1Style}><i className="fas fa-camera"></i> Certificate Winners</button></p>
                                    {listPage !== "my" && (
                                      <>
                                      <p><button onClick={() => handleAttendanceRegister(event._id)} style={button1Style}><i className="fas fa-check-square"></i> Attendance Register</button></p>
                                      <p><button onClick={() => handleShowFoodVoucherScroll(event._id)} style={button1Style}><i className="fas fa-utensils"></i> Food Voucher Scroll</button></p>
                                      <p><button onClick={() => handleButtonClick('Not Attended')} style={button1Style}><i className="fas fa-check-circle"></i> Not Attended Register</button></p>
                                      <p><button onClick={() => handleButtonClick('Guest Visit')} className='bg-gray-400' style={button1Style}><i className="fas fa-calendar-plus"></i> Unplanned / Guest Visit</button></p>
                                      <p><button onClick={() => handleButtonClick('Additional Members')} className='bg-gray-400' style={button1Style}><i className="fas fa-users"></i> Additional Members</button></p>
                                      <p><button onClick={() => handleMakePayment('Payment Register')} className='bg-gray-400' style={button1Style}><i className="fas fa-credit-card"></i> Payment Register</button></p>
                                      </>
                                   )}
                                  </div>
                                  {/* <div className="action-display flex justify-center">
                                    {selectedAction && (
                                        <h2 className="mb-4 text-blue-700 text-xl">{selectedAction}</h2>
                                    )}
                                  </div> */}
                                  {myRegistrationViewClicked && (
                                      <div className='flex flex-col justify-left px-4 bg-gray-800 text-white'>
                                        <p>Registration / Enrollment Number: {myRegistration.enrollmentNumber}</p>

                                        <p>Number of Members:{myRegistration.numberOfMembers}</p>
                                        <p>Member's Name:{myRegistration.membersName}</p>
                                        <p>Date Registered:{formatDateTime(myRegistration.dateCreated)}</p>
                                        <p>Fee Details:{myRegistration.feeDetails}</p>
                                        <p>Payment Mode:{myRegistration.paymentMode}</p>
                                        <p>Payment Date:{formatDateTime(myRegistration.paymentDate)}</p>
                                        <p>Payment Remarks:{myRegistration.paymentRemarks}</p>
                                      </div>
                                    )}
                                  {showHallTicket && (
                                      <div className='border-1 bg-black'>
                                          <p className='text-2xl text-red-500 flex justify-center items-center mb-4'>Event Hall / Entry Ticket</p>
                                          <p className='text-xl text-blue-700 flex justify-center items-center mb-4'>Dear {userName}, You are Coordially Invited for the Event</p>
                                          <p className='text-lg text-blue-700 flex justify-center items-center mb-4'>Following is Your Event Hall Ticket. Please bring it with you</p>
                                          <p className='text-xl text-orange-500 flex justify-center items-center mb-4'>Multipurpose WristScan Watch is Also Available on Payment with the Organiser.</p>
                                          <p className='flex justify-center items-center mb-4'>
                                            <QRCode value={userName+", "+userCode} size={256} className="flex justify-center items-center mb-4" />
                                          </p>
                                      </div>
                                  )}
                                  {showFoodVoucher && (
                                      <div className='border-1 bg-black'>
                                        <p className='text-2xl text-red-500 flex justify-center items-center mb-4'>Food Voucher</p>
                                        <p className='text-xl text-blue-700 mb-4'>Dear {userName}, Please use the following food voucher to pick your plate along with number of family members mentioned.</p>
                                        <p className='flex justify-center items-center mb-4'>
                                        <p>{myRegistration.numberOfMembers}</p>
                                          <QRCode value={userName+", "+userCode+", Member - "+"1"} size={128} className="flex justify-center mr-4 mb-4" />
                                          <QRCode value={userName+", "+userCode+", Member - "+"2"} size={128} className="flex justify-center mr-4 mb-4" />
                                          <QRCode value={userName+", "+userCode+", Member - "+"3"} size={128} className="flex justify-center mr-4 mb-4" />
                                          <QRCode value={userName+", "+userCode+", Member - "+"4"} size={128} className="flex justify-center mb-4" />
                                        </p>
                                      </div>                                  
                                  )}
                                  {foodVoucherScanned && (
                                      <div className='border-1 bg-black'>
                                          <p className='text-2xl text-red-500 flex justify-center items-center mb-4'>Utilising Food Voucher</p>
                                          <p className='text-lg text-blue-700 flex justify-center items-center mb-4'>Please scan the following at the Food Counter. Your kind co-operation is highly appreciated. </p>
                                          <p className='text-lg text-blue-700 flex justify-center items-center mb-4'>Thanks a lot for your kind co-operation in making food queue management smooth.. </p>
                                          
                                          <div className='flex flex-col justify-center items-center bg-lime-600 border border-red-500 mb-4 min-h-[100h]'>
                                            <p className='text-white text-lg'>Scanned By: <span>{userName}</span></p>
                                            <p className='text-white text-lg'>Scanned Date Time: <span>{formatDateTime(new Date())}</span></p>
                                          </div>
                                          <p className='flex justify-center items-center mb-4'>
                                            <EventFlowScanQR onScanSuccess={handleScanSuccess} />
                                          </p>
                                          <EventFoodCouponSaveAction 
                                            scanSource={'Image Scan'}
                                            scannedByUserId={userId}
                                            scannedByUserName={userName}
                                            scannedUserName={scannedUserName}
                                            scannedUserCode={scannedUserCode}
                                            consumedBy={consumedBy}
                                            mealType={mealType}
                                            isChild={isChild}
                                            event={event} 
                                            eventId={selectedEventId}
                                            eventTitle={event.title}
                                          />
                                      </div>
                                  )}
                                  {showFoodVoucherScroll && (
                                    <div className="mx-auto p-4 mt-4">
                                    <div className="bg-gray-700 p-6 rounded-lg shadow-lg">
                                      <h1 className="text-2xl font-bold text-blue-700 mb-4 text-center">Used Food Coupon Scroll</h1>
                                      <div className="overflow-x-auto">
                                        <div className="bg-gray-500 p-4 rounded-md shadow-md">
                                          {sortedEventFoodCouponScroll.length > 0 ? (
                                            sortedEventFoodCouponScroll.map((foodcoupon, index) => (
                                              <div key={foodcoupon._id} className="bg-blue-400 my-2 p-4 text-gray-600 rounded-md shadow-md">
                                                <p className="text-lg text-yellow-200 font-semibold">{index + 1}. {foodcoupon.scannedUserName}</p>
                                                <p className="text-sm text-white">Code: {foodcoupon.scannedUserCode}</p>
                                                <p className="text-sm text-white">Consumed By: {foodcoupon.consumedBy}</p>
                                                <p className="text-sm text-white">Adult / Child: {foodcoupon.isChild? "Child": "Adult"}</p>
                                                <p className="text-sm text-white">Meal Type: {foodcoupon.mealType}</p>
                                                <p className="text-sm text-white">Scanned On: {new Date(foodcoupon.scannedDate).toLocaleDateString()}</p>
                                              </div>
                                            ))
                                          ) : (
                                            <p className="text-center text-gray-500">No used Food Voucher / Coupon records found.</p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    </div>
                                  )}
                                  {markAttendance && (
                                      <div className='border-1 bg-black'>
                                          <p className='text-2xl text-red-500 flex justify-center items-center mb-4'>Visit Memo</p>
                                          <p className='text-lg text-blue-700 flex justify-center items-center mb-4'>Please scan the following at the ENTRY Gate during entry or in-event exit. Your kind co-operation is highly appreciated. </p>
                                          <p className='text-lg text-blue-700 flex justify-center items-center mb-4'>Thanks a lot for your kind co-operation and greate gesture in conducting the event soomthly.. </p>
                                        
                                          <div className='flex flex-col justify-center items-center bg-lime-600 border border-red-500 mb-4 min-h-[100h]'>
                                            <p className='text-white text-lg'>Scanned By: <span>{userName}</span></p>
                                            <p className='text-white text-lg'>Scanned Date Time: <span>{formatDateTime(new Date())}</span></p>
                                          </div>
                                          <p className='flex justify-center items-center mb-4'>
                                            <EventFlowScanQR onScanSuccess={handleScanSuccess} />
                                          </p>
                                          <EventAttendanceAction 
                                            scanSource={'Image Scan'}
                                            scannedByUserId={userId}
                                            scannedByUserName={userName}
                                            scannedUserName={scannedUserName}
                                            scannedUserCode={scannedUserCode}
                                            event={event} 
                                            eventId={selectedEventId}
                                            eventTitle={event.title}
                                          />
                                      </div>
                                  )}
                                  {showAttendance && (
                                    <div className="container mx-auto p-4 mt-4">
                                    <div className="bg-black p-6 rounded-lg shadow-lg">
                                      <h1 className="text-2xl font-bold text-blue-700 mb-4 text-center">Attendance Register</h1>
                                      <div className="overflow-x-auto">
                                        <div className="bg-gray-600 p-4 rounded-md shadow-md">
                                          {sortedEventAttendance.length > 0 ? (
                                            sortedEventAttendance.map((attendance, index) => (
                                              <div key={attendance._id} className="bg-blue-400 my-2 p-4 text-gray-600 rounded-md shadow-md">
                                                <p className="text-lg font-semibold">{index + 1}. {attendance.scannedUserName}</p>
                                                <p className="text-sm text-gray-500">Code: {attendance.scannedUserCode}</p>
                                                <p className="text-sm text-gray-500">Scanned On: {new Date(attendance.scannedDate).toLocaleDateString()}</p>
                                              </div>
                                            ))
                                          ) : (
                                            <p className="text-center text-gray-500">No attendance records found.</p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    </div>
                                  )}
                                  {showSplInstruction && (
                                      <div className='border-1 bg-black' dangerouslySetInnerHTML={{ __html: event.instructions }} />
                                  )}
                                </div>
                                {event.isActive === false && (
                                  <>
                                  <p className='mt-2'><strong>Current Status:</strong>{event.currentStatus}</p>
                                  <p><strong>Enroll Now:</strong>{event.enrollNow ? "Yes" : "No"}</p>
                                  <p><strong>Payment Method:</strong>{event.paymentMethod}</p>
                                  <p><strong>Contact Person / Organisor: </strong> {event.contactPerson}</p>
                                  <p>
                                      <button onClick={() => handleCallClick(event.contactNumber)} style={buttonStyle}>
                                      📞 Call
                                      </button>
                                      <button onClick={() => handleWhatsAppClick(event.contactNumber)} style={buttonStyle}>
                                      💬 WhatsApp
                                      </button>
                                      <button onClick={() => handleEmailClick(event.contactEmail)} style={buttonStyle}>
                                          ✉️ Email
                                      </button>
                                  </p>
                                  </>
                                )}
                                </div>
                            )}
                            </div>
                        ))
                        )}
                    </div>
                    )}
                </div>
            {/* </div> */}
        </div>
        </MainLayout>
    );
};

export default EventList;
